<cyborg-section id="popular">
  <cyborg-section-title>
    <div class="logo">
      <span>Recently Updated Hunt Packages</span>
    </div>
  </cyborg-section-title>
  <hunt-package
    *ngFor="let packages of recentHuntPackages$ | async"
    [data]="packages"
  ></hunt-package>
</cyborg-section>
